import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import CR1 from '../assets/CR1.png';
import CBR1 from '../assets/CBR1.png';

const products = [
    {
        id: 'cr',
        title: 'Coated Reels',
        image: CR1,
        description: 'LDPE extruded coated reels made of 100% virgin fiber paper with 1PE & 2PE options.',
        details: [
            'Materials: Paper',
            'GSM: 60 to 350',
            'Color: White',
            'Options: 1PE & 2PE',
            'Usage: Industrial Packaging / Disposables'
        ],
        modalDescription: 'LDPE extruded coated reels made of 100% virgin fiber paper, used in industrial packaging and disposables.'
    },
    {
        id: 'cbr',
        title: 'Coated Bottom Reels',
        image: CBR1,
        description: 'LDPE coated bottom reels made from virgin fiber paper for paper cups (1PE & 2PE).',
        details: [
            'Materials: Paper',
            'GSM: 60 to 350',
            'Color: White',
            'Options: 1PE & 2PE',
            'Usage: Paper Cups'
        ],
        modalDescription: 'Specially designed for disposable paper cup bottoms with LDPE coating (1PE & 2PE).'
    }
];

const IntermediateProducts = () => {
    const [openModal, setOpenModal] = useState(null);

    const closeModal = () => setOpenModal(null);

    return (
        <>
            <Navbar />
            <section id="products" className="py-20 bg-gray-100 min-h-screen">
                <div className="container mx-auto px-5">
                    <h2 className="text-center text-4xl mb-16 text-[#2c5530] font-bold relative after:content-[''] after:absolute after:bottom-[-10px] after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-1 after:bg-gradient-to-r after:from-[#ff6b6b] after:to-[#ffa500] after:rounded">
                        Intermediate Products
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
                        {products.map(({ id, title, image, description }) => (
                            <div
                                key={id}
                                className="product-card bg-white rounded-2xl overflow-hidden shadow-xl hover:-translate-y-2 hover:shadow-2xl transition-all cursor-pointer flex flex-col h-[360px]"
                                onClick={() => setOpenModal(id)}
                            >
                                <div className="h-48 bg-white flex items-center justify-center">
                                    <img src={image} alt={title} className="object-contain" style={{ width: '200px', height: '200px' }} />
                                </div>
                                <div className="p-6 flex flex-col flex-grow justify-between">
                                    <div>
                                        <h3 className="text-xl text-[#2c5530] mb-2 font-semibold text-center">{title}</h3>
                                        <p className="text-sm text-gray-600 text-center">{description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {openModal && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={closeModal}
                >
                    <div
                        className="bg-white p-6 rounded-lg w-full max-w-md relative shadow-lg"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={closeModal}
                            className="absolute top-2 right-3 text-gray-600 text-2xl font-bold"
                            aria-label="Close modal"
                        >
                            &times;
                        </button>
                        {products.map(
                            ({ id, title, image, modalDescription, details }) =>
                                openModal === id && (
                                    <div key={id}>
                                        <h3 className="text-2xl text-[#2c5530] font-semibold mb-4">{title}</h3>
                                        <img src={image} alt={title} className="w-full h-48 object-contain mb-4" />
                                        <p className="mb-2">{modalDescription}</p>
                                        <ul className="list-disc pl-5 text-sm">
                                            {details.map((detail, idx) => (
                                                <li key={idx}>{detail}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default IntermediateProducts;